export { SelectormesModule } from './selectormes.module';
export { Selectormes } from './selectormes.component';
